const MonsterSection = {
  state: {
    monsterData: [
      {
        monsterImg: 'monster-normal01.png',
        name: 'Souly',
        desc:
          'Spirits who enjoy causing bad accidents to people. Originally, they are supposed to disappear naturally in time, but the condition became very unstable as they were forced to become followers. So they do whatever they want, causing a lot of accidents and became a nuisance within demons.',
      },
      {
        monsterImg: 'monster-normal02.png',
        name: 'Parrot Butler',
        desc:
          'Training butlers in the appearance of a parrot working in Rosengarten. They were once followers of Malpas. They came to Rosengarten when Malpas was expelled from the demon world. They are known as the "traitor parrot" among demons.',
      },
      {
        monsterImg: 'monster-normal03.png',
        name: 'Q-riring',
        desc:
          "Prirings that have been demonized by entering the demonic world. Originally, they were normal Pririrngs that play in the grass. There's also a story that demons that fell in love with Prirings' cuteness took them to raise the",
      },
      {
        monsterImg: 'monster-normal04.png',
        name: 'Evil Bear',
        desc:
          'Devil bear dolls who make people have nightmares for a long time. They used to be loved by demons for their unique cuteness and fluffiness. Recently, they began to pick a fight with parrot butlers.',
      },
      {
        monsterImg: 'monster-normal05.png',
        name: 'Royal Succubus',
        desc:
          'High ranking succubus that follows Asmodea. They are noble and arrogant in everything. They fascinate the souls of people and life and turn them into their own. While following Asmodea, they often compete with other succubus.',
      },
      {
        monsterImg: 'monster-normal06.png',
        name: 'Vampire',
        desc:
          'Members of the vampire family who work in Rosengarten. Survivors of the Vampire Kingdom, which was destroyed by the demon lord Lux. They work as much as they want. They also have various types of jobs, including engineers, butlers, and doctors.',
      },
      {
        monsterImg: 'monster-normal07.png',
        name: 'Stalker',
        desc:
          "Devils that cannot think for themselves. They are said to be mentally connected to monitors dispatched to the human world and receive information. However, it's not known how they receive the information.",
      },
    ],
    monsterPaging: [
      'monster-normal1-icon.png',
      'monster-normal2-icon.png',
      'monster-normal3-icon.png',
      'monster-normal4-icon.png',
      'monster-normal5-icon.png',
      'monster-normal6-icon.png',
      'monster-normal7-icon.png',
    ],
  },
};

export default MonsterSection;
